import { TitleSectionWithImage } from '../../ui/Components/VotingTitle';
import type { ModuleComponentProps } from '../types';

export function Content({ question }: ModuleComponentProps) {
  const {
    question_description,
    title_meta,
    image,
    question: title,
    question_styled,
  } = question;

  return (
    <TitleSectionWithImage
      description={question_description}
      title={title}
      titleStyled={question_styled}
      meta={title_meta}
      image={image}
    />
  );
}
